<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="close"
    @submit="confirm"
    class="addlinks-dialog"
  >
    <telegram-form
      ref="form"
      :form-data="formData"
      :editing="true"
      @submit="submitHandle"
    ></telegram-form>
  </sliderBarDialogShell>
</template>

<script>
import { buildTelegramConfigPayload, editTelegramConfig } from '@/api/sys/robitConfig/telegram'
import telegramForm from '@/components/sys/robitCofig/telegram/telegramForm'

export default {
  name: 'editTelegram',
  components:{
    telegramForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
    }
  },
  data() {
    return {
      title: '编辑Telegram推送渠道',
    }
  },

  methods: {

    close(){
      this.$refs.form.$refs.form.clearValidate();
      this.$emit('close');
    },

    cancel(){
      this.close();
    },
    confirm() {
      this.$refs.form.validate();
    },
    submitHandle(formData){
        editTelegramConfig(buildTelegramConfigPayload(formData, true)).then(() => {
        this.$refs.form.$refs.form.clearValidate();
            this.$refs.form.$refs.form.resetFields();

            this.$emit('edit-success');
        this.$refs.form.reset();
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addlinks-dialog {
  .el-select {
    width: 100%;
  }
}
</style>
